(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-jannis-product-card-cleanup"]) return;
  try {
    
if (!customElements.get('jannis-product-card-cleanup')) {
  customElements.define('jannis-product-card-cleanup', class extends HTMLElement {
    connectedCallback() {
      this.scheduleCleanup = this.scheduleCleanup.bind(this);
      this.clean = this.clean.bind(this);
      this.scheduleCleanup();
      this.observer = new MutationObserver(this.scheduleCleanup);
      this.observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    scheduleCleanup() {
      if (this.cleanupQueued) {
        return;
      }

      this.cleanupQueued = true;
      requestAnimationFrame(() => {
        this.cleanupQueued = false;
        this.clean();
      });
    }

    clean() {
      this.targetSections().forEach((section) => {
        section.querySelectorAll('product-card, .product-card').forEach((card) => this.cleanCardRatings(card));
      });
    }

    targetSections() {
      return document.querySelectorAll('#shopify-section-featured-collection, #shopify-section-featured_collection_WfUPjR, [id$="__featured-collection"], [id$="__featured_collection_WfUPjR"]');
    }

    cleanCardRatings(card) {
      let hasVisibleRating = false;

      this.ratingElements(card).forEach((rating) => {
        if (!this.looksLikeRating(rating)) {
          return;
        }

        if (hasVisibleRating) {
          rating.hidden = true;
          return;
        }

        hasVisibleRating = true;
        this.hideReviewCount(rating);
      });
    }

    ratingElements(card) {
      return [...card.querySelectorAll('.product-card__rating, .rating, .rating-badge, .spr-badge, .jdgm-prev-badge, .loox-rating, [class*="areviews"], [class*="rating"], [class*="review"]')]
        .filter((element) => element instanceof HTMLElement && !element.closest('script, style') && element.textContent.trim());
    }

    looksLikeRating(element) {
      const text = element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      return text.includes('\u2605') || text.includes('\u2606') || text.includes('bewertung') || text.includes('review') || /\(\s*\d[\d.,]*\s*\)/.test(text);
    }

    hideReviewCount(rating) {
      rating.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.replace(/\s*\(\s*\d[\d.,]*\s*\)\s*/g, ' ');
        }
      });

      rating.querySelectorAll('*').forEach((element) => {
        if (/^\(\s*\d[\d.,]*\s*\)$/.test(element.textContent.trim())) {
          element.hidden = true;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
